import React from 'react';
import { motion } from 'framer-motion';
import { Upload, Sparkles, FileText } from 'lucide-react';
export function HowItWorksSection() {
  const steps = [{
    icon: <Upload className="w-6 h-6 text-indigo-400" data-id="element-2778" />,
    title: 'Upload Conversations',
    description: 'Securely upload your chat screenshots or text exports. Your data is encrypted and private.'
  }, {
    icon: <Sparkles className="w-6 h-6 text-cyan-400" data-id="element-2779" />,
    title: 'AI Analysis',
    description: 'Our models analyze the communication for emotional patterns, tone, and hidden dynamics.'
  }, {
    icon: <FileText className="w-6 h-6 text-purple-400" data-id="element-2780" />,
    title: 'Receive Insights',
    description: 'Get a clear, objective report detailing communication styles, red flags, and healthy patterns.'
  }];
  return <section className="py-24 bg-[#050505] relative overflow-hidden border-t border-gray-900" data-id="element-2781">
      <div className="max-w-6xl mx-auto px-6 relative z-10" data-id="element-2782">
        <div className="text-center mb-16" data-id="element-2783">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight" data-id="element-2784">
            How it works
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto" data-id="element-2785">
            Three simple steps to gain objective clarity on your digital
            interactions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-2786">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} className="bg-[#0A0A0A] border border-gray-800 rounded-2xl p-8 hover:border-gray-700 transition-colors" data-id="element-2787">
              <div className="w-12 h-12 bg-white/5 rounded-xl flex items-center justify-center mb-6 border border-white/10" data-id="element-2788">
                {step.icon}
              </div>
              <h3 className="text-xl font-semibold text-white mb-3" data-id="element-2789">
                {step.title}
              </h3>
              <p className="text-gray-400 leading-relaxed text-sm" data-id="element-2790">
                {step.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}